export default __webpack_public_path__ + "static/media/logo-rtl.a72b0ef5.svg";